<select
  #selectElement
  [required]="required"
  [disabled]="disabled"
  [value]="value"
  (change)="valueChange.emit($event.target.value)"
  [focusOnInit]="autoFocus"
  tabindex="0"
>
  <option *ngIf="placeholder !== undefined && !value" [value]="null" disabled>
    {{ placeholder }}
  </option>
  <ng-content></ng-content>
</select>
